import Vue from 'vue'
import GmapVue from 'gmap-vue'
import { Storage } from '@/modules/plugins/storage'

Vue.use(GmapVue, {
    load: {
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: 'places',
        region: process.env.VUE_APP_LOCATION,
        language: Storage.getItem('locale'),
    },
    installComponents: false,
})
